import { CatalogTransferUploadedDocument } from '@Entities/rightsholder/catalog-transfer-uploaded-document'
import React from 'react'
import { formatBytes } from '@App/helpers/format-bytes'
import Button from '@Components/Buttons/Button'

interface ReviewFilesListProps {
    uploadedDocs: CatalogTransferUploadedDocument[] | undefined
    onDownloadFile?: (catalogTransferMemberUploadId: number) => void
}
const ReviewFilesList = ({ uploadedDocs = [], onDownloadFile }: ReviewFilesListProps) => (
    <ul className="review-file-list">
        {uploadedDocs
            .filter((doc) => doc.uploadType === 'DOCUMENTATION')
            .map((doc) => (
                <li key={doc.memberUploadId}>
                    {onDownloadFile ? (
                        <div className="file-download-section">
                            <div>{doc.name}</div>
                            <div className="file-download-link">
                                <Button mainColor type="tertiary" onClick={() => onDownloadFile(doc.id)}>
                                    Download
                                </Button>
                            </div>
                            <div>{formatBytes(doc.size)}</div>
                        </div>
                    ) : (
                        <>{doc.name}</>
                    )}
                </li>
            ))}
    </ul>
)

export default ReviewFilesList
